import { render, staticRenderFns } from "./PaginatedTablePagination.vue?vue&type=template&id=035d2cd2&scoped=true&"
import script from "./PaginatedTablePagination.vue?vue&type=script&lang=js&"
export * from "./PaginatedTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedTablePagination.vue?vue&type=style&index=0&id=035d2cd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d2cd2",
  null
  
)

export default component.exports